
import Vue from "vue";
import AppSellPriceCategorySelect from "@/components/SellPriceCategorySelect.vue";
import AppSellPriceCategoryMultiSelect from "@/components/SellPriceCategoryMultiSelect.vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data(){
		return {
			multiSelectValue: [] as number[]
		};
	},
	props: {
		value: {
			type: [String, Array as ()=>string[]],
			required: true
		},
		multi: Boolean,
		label: {
			type: [Object as ()=>TranslateResult, String],
			default():TranslateResult{
				if (this.multi) return this.$ct("sell-prices");
				return this.$ct("sell-price");
			}
		}
	},
	computed: {
		singleValue():number | undefined {
			if (typeof(this.value) == "object"){
				return parseInt(this.value[0]);
			}
			return parseInt(this.value);
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				// Fix empty values in filter
				if (!this.multi) return;
				if (!Array.isArray(this.value)) return;
				for (let i = this.value.length - 1; i>=0; i--){
					if (this.value[i] == "") {
						this.value.splice(i, 1);
					}
				}
				this.multiSelectValue = this.value.map(v=>parseInt(v));
			}
		}
	},
	methods: {
		setSingleValue(value:string){
			this.$emit("input", `${value}`);
		},
		onMultiSelectInput(value:number[]){
			this.$emit("input", value.map(v=>`${v}`));
		}
	},
	components: {
		AppSellPriceCategorySelect,
		AppSellPriceCategoryMultiSelect
	},
	i18nEx: {
		componentPrefix: "components.models"
	}
});
